var $ = require('jquery');

$('#content').on('click', '.view-simple-modal', function() {
    var modal = $('#simpleModal').clone();

    modal.find('.modal-dialog').addClass($(this).data('modal-size'));

    modal.find('.modal-content').html($(this).data('content').clarify());
    modal.modal('show');

    modal.on('hidden.bs.modal', function () {
        modal.remove();
    });
});

$('#content').on('click', '.view-transcoding-errors', function() {
    var modal = $('#simpleModal').clone();
    var errors = $(this).data('errors');

    modal.find('.modal-content').html(errors);
    modal.modal('show');

    modal.on('hidden.bs.modal', function () {
        modal.remove();
    });
});
